'use strict';

import _ from 'lodash';
import React from 'react';
import Analytics from '../common/analytics';

class Multimedia extends React.Component {

  constructor(props) {
    super(props);
  }

  renderLightBox = () => {
    setTimeout(() => {
      let featured = $('.media-wrap a');
      let all = $('#all-photos');
      let featuredChild = $('#all-photos figure:first-child a');

      if (!$._data(featured[0]).events) {
        all.slickLightbox({ itemSelector: 'figure a' });
        featured.on('click', (evt) => { evt.preventDefault(), featuredChild.trigger('click') });
      }
    });
  }

  render() {
    let renderLightBox = this.renderLightBox();
    let featuredPhoto = this.props.conference.current.media && this.props.conference.current.media.slideshows ?
      _(this.props.conference.current.media.slideshows[0].images).values().first() :
      null;
    if (featuredPhoto) {
      // http://www.pionline.com/galleryimage/CO/20130917/conferences/100809999/PH/0/1/PH-100809999.jpg
      // https://crain-platform-cpi-prod.s3.amazonaws.com/s3fs-public/styles/1152x647/public/CONFERENCES_100809999_PH_1_0.jpg
      featuredPhoto = featuredPhoto.replace(/^http:\/\/www\.pionline\.com\/galleryimage\/CO\/\d{8}\/conferences\/(\d+)\/.*$/,'https://crain-platform-cpi-prod.s3.amazonaws.com/s3fs-public/styles/1152x647/public/CONFERENCES_$1_PH_1_0.jpg');
    }
    let featuredVideo = this.props.conference.current.media && this.props.conference.current.media.video_html ? this.props.conference.current.media.video_html : null;

    return <div className="multimedia">
      <section className="section">
        <div className="wrap-one clearfix">
          <div className="title">Videos</div>
        </div>
      </section>
      {!featuredVideo ? null :
        <div>
          <div id="featured-photo-video" className="secondary-section media">
            <div className="wrap-one">
              <div className="bio-wrap clearfix">
                <div className="video">
                  <div className="media-wrap">
                    <div id="featured-video-container" className="embed-responsive"
                      dangerouslySetInnerHTML={{ __html: featuredVideo }}>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {!featuredPhoto ? null :
        <div>
          <div id="featured-photo-video" className="secondary-section media">
            <div className="wrap-one">
              <div className="bio-wrap clearfix">
                <figure className="photo">
                  <div className="media-wrap">
                    <a href={[featuredPhoto, '?imageversion=widescreen&maxH=250'].join('')} target="_blank">
                      <span className="icon-slideshow"></span>
                      <img src={[featuredPhoto, '?imageversion=widescreen&maxH=250'].join('')} />
                    </a>
                  </div>
                  <figcaption>
                    <h3>Slide Show</h3>
                    <div>Photos From the Event</div>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
          <section id="all-photos" className="section no-border video-photo media" >
            <div className="photos wrap-one clearfix">
              <div className="title sub">All Photos</div>
              <div className="bio-wrap clearfix">
                {_.map(this.props.conference.current.media.slideshows[0].images, (photo, k) => {
                  // http://www.pionline.com/galleryimage/CO/20130917/conferences/100809999/PH/0/1/PH-100809999.jpg
                  // https://crain-platform-cpi-prod.s3.amazonaws.com/s3fs-public/styles/1152x647/public/CONFERENCES_100809999_PH_1_0.jpg
                  photo = photo.replace(/^http:\/\/www\.pionline\.com\/galleryimage\/CO\/\d{8}\/conferences\/(\d+)\/PH\/(\d+)\/(\d+)\/.*$/,'https://crain-platform-cpi-prod.s3.amazonaws.com/s3fs-public/styles/1152x647/public/CONFERENCES_$1_PH_$3_$2.jpg');
                  return <figure key={k} className="photo">
                    <a href={photo} target="_blank">
                      <img src={photo} />
                    </a>
                  </figure>
                })}
              </div>
            </div>
          </section>
        </div>
      }
      <Analytics view="multimedia" {...this.props} />
    </div>
  }
}

export default Multimedia;
